import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { Task } from '../../data/types';

export type CaseTaskState = {
    tasks: Task[],
}

export const useCaseTaskState = () => {
    const taskState = useSelector((state: RootState | any) => state.caseTasks as CaseTaskState);
    return taskState;
}

// Define the initial state using that type
const initialState: CaseTaskState = {
    tasks: [],
}

export const caseTaskSlice = createSlice({
    name: 'caseTasks',
    initialState: initialState,
    reducers: {
        setCaseTasksAction: (state, action: PayloadAction<Task[]>) => {
            state.tasks = action.payload;
        },
        addOrReplaceCaseTaskAction: (state, action: PayloadAction<Task>) => {
            const existingIndex = state.tasks.findIndex((task: Task) => task?.taskId === action.payload.taskId);
            if (existingIndex >= 0) {
                state.tasks[existingIndex] = action.payload;
            } else {
                state.tasks.push(action.payload);
            }
        },
        addOrReplaceCaseTasksAction: (state, action: PayloadAction<Task[]>) => {
            action.payload.forEach((task) => {
                const existingIndex = state.tasks.findIndex((t: Task) => t?.taskId === task.taskId);
                if (existingIndex >= 0) {
                    state.tasks[existingIndex] = task;
                } else {
                    state.tasks.push(task);
                }
            });
        },
        deleteCaseTaskAction: (state, action: PayloadAction<string>) => {
            state.tasks = state.tasks.filter((x) => x.taskId !== action.payload);
        },
    }
})

export const { addOrReplaceCaseTaskAction, addOrReplaceCaseTasksAction, setCaseTasksAction, deleteCaseTaskAction } = caseTaskSlice.actions;
export default caseTaskSlice.reducer;